'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

require('venobox');

require('slick-carousel');

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('./handlers');

var _handlers2 = _interopRequireDefault(_handlers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleOptionSelect = function handleOptionSelect(event) {
  var isVariantTrigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var $this = $(event.currentTarget);
  var $optionGroup = $this.closest(_Dom2.default.pdpOptionsGroup);
  var $optionsContext = $this.closest(_Dom2.default.pdpOptions);

  $optionGroup.find(_Dom2.default.pdpOption).removeClass('is-active');
  $this.addClass('is-active');

  // handle situation with straps that are default product template
  var isSingleProductPage = window.bvaccel.template.name === 'product' && window.bvaccel.template.alternate !== 'parent-child';
  var isStrapGuide = window.bvaccel.template.name === 'page' && window.bvaccel.template.alternate === 'strap-guide';

  if ((isSingleProductPage || isStrapGuide) && !isVariantTrigger) {
    var activeOption = $optionsContext.find(_Dom2.default.pdpOptionValue + '.is-active');
    var value = activeOption.attr('data-option-value');
    var optionIndex = $this.parent().parent().data('product-option-index');
    var handle = $optionsContext.attr('data-product-options');
    var variant = _handlers2.default.getVariant(optionIndex, value, handle);

    _handlers2.default.updateProduct(handle, variant);
    $(_Dom2.default.pdpImageGallery).slick('slickGoTo', activeOption.index(_Dom2.default.pdpOptionValue));
    return;
  }

  var optionCount = _handlers2.default.getProductOptionsCount($optionsContext);
  var $activeOptions = $(_Dom2.default.pdpOption + '.is-active', $optionsContext);

  if (optionCount === $activeOptions.length) {
    // Product trigger
    if (!isVariantTrigger) {
      var $activeProductOptions = $(_Dom2.default.pdpOptionValue + '.is-active', $optionsContext);
      var handlePrefix = $optionsContext.attr('data-product-options');
      var handleSuffix = $activeProductOptions.map(function (index, option) {
        return $(option).attr('data-value');
      }).get().join('-');
      var _handle = handlePrefix + '-' + handleSuffix;

      var activeOptionValues = $activeProductOptions.map(function (index, option) {
        return $(option).attr('data-option-value');
      }).get();

      _handle = _handlers2.default.checkHandle(_handle, activeOptionValues, $optionsContext);

      // check for active variant
      var $activeVariant = $optionsContext.find(_Dom2.default.pdpVariantValue + '.is-active');

      if ($activeVariant.length) {
        var _value = $activeVariant.attr('data-option-value');
        var _optionIndex = $activeVariant.attr('data-option-index');
        var _variant = _handlers2.default.getVariant(_optionIndex, _value, _handle);

        _handlers2.default.updateProduct(_handle, _variant);
      } else {
        _handlers2.default.updateProduct(_handle);
      }
    }
    // Variant trigger
    else {
        var _value2 = $this.attr('data-option-value');
        var _optionIndex2 = $this.attr('data-option-index');

        _handlers2.default.updateVariant(_optionIndex2, _value2);
      }
  } else {
    var _variant2 = {
      available: false
    };

    _handlers2.default.updateATC(_variant2);
  }
};

var handleCheckboxKeyPress = function handleCheckboxKeyPress(event) {
  var code = event.KeyCode ? event.KeyCode : event.which;

  if (code === 13) {
    $(event.currentTarget).trigger('click');
  }
};

var handleBISToggle = function handleBISToggle() {
  $(_Dom2.default.addToCart).toggleClass('u-hidden');
  $(_Dom2.default.bis).toggleClass('u-hidden');
};

var buttonColorUpdate = function buttonColorUpdate() {
  var scroll = $(window).scrollTop();

  if (scroll > 300) {
    $('body .cart-btn.cart-btn--sticky').css({
      'background-color': '#53c563',
      'border-color': '#53c563'
    });
  }
};

// test: PDP Promotion Messaging
var DYpromoMessageTest = function DYpromoMessageTest() {
  var text = $('.product-tag-wrapper .product-tag').text();

  if (text === '30% off with code') {
    $('.dy-promo-messanging-text').remove();
  }
};

var bindActions = exports.bindActions = function bindActions() {
  $(document).on('click', _Dom2.default.pdpOptionValue, handleOptionSelect);

  $(document).on('click', _Dom2.default.pdpVariantValue, function (event) {
    return handleOptionSelect(event, true);
  });

  $(document).on('keypress', _Dom2.default.pdpUpsellCheckbox, handleCheckboxKeyPress);

  $(document).on('click', _Dom2.default.bisToggle, handleBISToggle);

  $(window).on('scroll', buttonColorUpdate);

  // DYpromoMessageTest();

  $('[data-venobox-init]').venobox();
};